type Props = {
  LanguageState: string;
  seAboutPageHeader: string;
  seAboutPageBody: string;
  enAboutPageHeader: string;
  enAboutPageBody: string;
};

export default function AboutArea({
  LanguageState,
  seAboutPageHeader,
  seAboutPageBody,
  enAboutPageHeader,
  enAboutPageBody,
}: Props) {
  return (
    <div className="flex flex-col w-full max-w-7xl mx-auto py-safe-offset-12 overflow-auto scrollbar-hide">
      <div className="sparkar">
        <div className="px-safe-offset-8 py-24 md:py-36 lg:py-56 flex flex-col space-y-4 mx-auto h-full justify-center items-center text-white text-2xl text-center">
          <h1 className="text-4xl font-display font-medium tracking-wider">
            {LanguageState === "swedish"
              ? seAboutPageHeader
              : enAboutPageHeader}
          </h1>
        </div>
      </div>
      <div className="px-safe-offset-4 mb-safe-offset-4">
        <div className="bg-[#DBE3E7] dark:bg-zinc-800 p-4 sm:p-6 md:p-8 lg:p-10 max-w-3xl rounded-lg text-sm mx-auto -mt-10 md:-mt-20">
          <div className="flex flex-col space-y-4">
            {LanguageState === "swedish" ? (
              // <div>
              //   <div className="text-base font-medium mb-6 leading-7">
              //     <p>
              //       Projektet ”Smarta sparkar för välgörenhet” är ett
              //       samarbetsprojekt mellan Lunet, Luleå Kommuns parksektion,
              //       Fritidshemsutvecklarna och kommunala fritidshem.
              //     </p>
              //     <p>
              //       Fritidshem har fått möjligheten att dekorera en spark som
              //       sedan ställts ut på isvägen.
              //     </p>
              //     <p>
              //       Sparkarna är utrustade med sensorer som samlar in
              //       information om position, tillgänglighet och distans. För
              //       varje kilometer som sparkarna går gemensamt skänker Lunet 1
              //       kr till Region Norrbotten – Sunderbyns barnavdelning.
              //       (upptill ett maxbelopp på 10.000 kr).
              //     </p>
              //   </div>
              //   <div className="text-xl font-bold mb-2">Om LoRaWAN</div>
              //   <div className="text-base font-medium leading-7">
              //     <p>
              //       LoRaWAN möjliggör en infrastruktur för IoT, där apparater är
              //       uppkopplade mot nätet och gör det möjligt att samla in data
              //       på distans.
              //     </p>
              //     <p>
              //       Fördelen med LoRaWAN är den låga energiförbrukningen med en
              //       förhållandevis lång räckvidd. Sensorer som är utplacerade
              //       drivs av batterier och kan vara installerade i flera år
              //       innan batteribyte behöver ske.
              //     </p>
              //     <p>
              //       Det finns en mängd tillämpningsområden där LoRaWAN kan
              //       förenkla, effektivisera och förbättra vår vardag. Sensorerna
              //       kan tala om när åtgärder behövs, exempelvis när planteringar
              //       och träd behöver vatten, när soporna behöver tömmas eller
              //       när det är risk för halka.
              //     </p>
              //     <p>
              //       På sjukhus kan sensorer sättas på medicinsk utrustning för
              //       att enkelt se var på sjukhuset den befinner sig.
              //     </p>
              //     <p>
              //       Du kan läsa mer om vårt LoRa WAN sensornät{" "}
              //       <a
              //         href="https://lunet.se/smarta-tjanster/"
              //         target="_blank"
              //         rel="noreferrer"
              //         className="text-left text-lunet-red-500"
              //       >
              //         här
              //       </a>
              //       .
              //     </p>
              //   </div>
              // </div>
              <div className="content" dangerouslySetInnerHTML={{ __html: seAboutPageBody }} />
            ) : (
              // <div>
              //   <div className="text-base font-medium mb-6 leading-7">
              //     The project ”Smart kick-sledges for charity” has been carried
              //     out in collaboration between Lunet, the schools in Luleå, the
              //     school developers and the park section of the municipality.
              //     <br></br>
              //     The kick-sledges are designed by children from 21 schools in
              //     Luleå and everyone is welcome to use them while visiting the
              //     ice road.
              //     <br></br>
              //     The kick-sledges are equipped with sensors that collect
              //     information about position, availability and distance.
              //     Together with the schools, we collect money for charity. Lunet
              //     donates 1 SEK per kilometer to the Children’s hospital in
              //     Luleå.
              //   </div>
              //   <div className="text-xl font-bold mb-2">About LoRaWAN</div>
              //   <div className="text-base font-medium leading-7">
              //     LoRaWAN is a networking protocol designed to wirelessly
              //     connect battery operated ‘things’ to the internet.
              //     <br></br>
              //     The advantage of LoRaWAN is the low power consumption and long
              //     range communication between end devices and a gateway.
              //     <br></br>
              //     There are many areas where LoRaWAN can help us in our daily
              //     life. The sensors can send us information when action is
              //     required, for example when the threes or flowers needs water,
              //     when the bins needs to be emptied.
              //     <br></br>
              //     <br></br>
              //     Read more about LoRaWAN{" "}
              //     <a
              //       href="https://lunet.se/smarta-tjanster/"
              //       target="_blank"
              //       rel="noreferrer"
              //       className="text-left text-lunet-red-500"
              //     >
              //       here
              //     </a>
              //     .
              //   </div>
              // </div>
              <div className="content" dangerouslySetInnerHTML={{ __html: enAboutPageBody }} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
